import { post } from '@u';
export const applyService = param => post('/manager/apply/forCompanyService', param);
export const getCurrentNot = () => get('/language/currentNotLogin');
export const setCurrentNot = type => post('/language/setCurrentNotLogin', { langCode: type });
